import { clientActionType } from '../../constants';

const clientReducer = (state = [], action) => {
    switch (action.type) {
        case clientActionType.FETCH_CLIENTS:
            return action.payload;
       
        default:
            return state;
    }
};
export default clientReducer